import ItemChange from 'owa-service/lib/contract/ItemChange';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';
import message from 'owa-service/lib/factory/message';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import setItemField from 'owa-service/lib/factory/setItemField';
import deleteItemField from 'owa-service/lib/factory/deleteItemField';
import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import getOutboundCharset from 'owa-session-store/lib/selectors/getOutboundCharset';

/**
 * @param itemIds item ids for which new retention tag needs to be set
 * @param isArchiveTag whether archive or policy tag is being set
 * @param tag the new tag to be set for the items
 * @param requestOptions request options
 */
export default function setItemRetentionPolicy(
    itemIds: string[],
    isArchiveTag: boolean,
    tag: RetentionTagType,
    requestOptions: RequestOptions
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(itemIds, isArchiveTag, tag);

    return updateItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    });
}

function createRequestBody(itemIds: string[], isArchiveTag: boolean, tag: RetentionTagType) {
    const fieldURI = isArchiveTag ? 'ItemArchiveTag' : 'ItemPolicyTag';
    const itemTag = isArchiveTag ? 'ArchiveTag' : 'PolicyTag';
    const propertyUpdates = [
        tag
            ? setItemField({
                  Path: propertyUri({ FieldURI: fieldURI }),
                  Item: message({ [itemTag]: tag }),
              })
            : deleteItemField({
                  Path: propertyUri({ FieldURI: fieldURI }),
              }),
    ];
    const itemChanges: ItemChange[] = [];
    itemIds.forEach((id: string) =>
        itemChanges.push(
            itemChange({
                Updates: propertyUpdates,
                ItemId: itemId({ Id: id }),
            })
        )
    );

    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
        SuppressReadReceipts: false,
        ClientSupportsIrm: true,
        SendCalendarInvitationsOrCancellations: 'SendToNone',
        ...getOutboundCharset(),
    });
}
